<body>
    <div>
        <div class="center-container">
            <div class="content-area">
                <!-- Stepper - Sidebar -->
                <div class="sidebar">
                    <div *ngIf="!isEditMode" class="role-title">Create a new scenario</div>
                    <div *ngIf="isEditMode"   class="role-title">Editing {{ scenario_name }}</div>
                    <app-stepper [isEditMode]="isEditMode" (changeStepperEvent)="changeStepper($event)"></app-stepper>
                </div>
                    <!-- Form Elements-->
                    <div class="container">
                        <div class="inner-container">
                            <form [formGroup]="step4Form" (ngSubmit)="goToStep(5)" class="stepper3-form">
                              <div class="title" id="innercontainer">
                                  <div class="tell-us-block">
                                      <span class="paraTell">Attitude/Communication Style for Customer</span>
                                  </div>
                                  <div class="inner-block">
                                      <div class="cust">
                                          <label class="labels">Emotional state:</label>
                                      </div>
                                        <div formArrayName="emotionalState">
                                            <div class="cust row-1" *ngFor="let objective of emotionalState.controls; let i = index" >
                                                <input class="input-box" type="text"
                                                [formControlName]="i" placeholder="Add new Emotional State">
                                                <img class="jj-close" (click)="removeInput(i, 'E')" src="../../../../assets/images/JJ_Icon_Close.svg" alt="">
                                            </div>
                                            </div>
                                      <div class="checkbox-list">
                                        <button type="button" (click)="addValueInput('E')">Add New +</button>
                                    </div>
                                      <div class="cust">
                                        <label class="labels">Attitude:</label>
                                    </div>
                                        <div formArrayName="attitude">
                                            <div class="cust row-1" *ngFor="let objective of attitude.controls; let i = index" >
                                                <input class="input-box" type="text"
                                                [formControlName]="i" placeholder="Add new Attitude">
                                                <img class="jj-close" (click)="removeInput(i, 'A')" src="../../../../assets/images/JJ_Icon_Close.svg" alt="">
                                            </div>
                                            </div>
                                    <div class="checkbox-list">
                                        <button type="button" (click)="addValueInput('A')">Add New +</button>
                                    </div>
                                    <div class="cust">
                                        <label class="labels">Communication Style</label>
                                    </div>
                                        <div formArrayName="communicationStyle">
                                            <div class="cust row-1" *ngFor="let objective of communicationStyle.controls; let i = index" >
                                                <input class="input-box" type="text"
                                                [formControlName]="i" placeholder="Add new Communication Style">
                                                <img class="jj-close" (click)="removeInput(i, 'C')" src="../../../../assets/images/JJ_Icon_Close.svg" alt="">
                                            </div>
                                            </div>
                                    <div class="checkbox-list">
                                        <button type="button" (click)="addValueInput('C')">Add New +</button>
                                    </div>
                                  </div>
                              </div>
                          </form>
                          </div>
                    </div>
                    <div class="cancel-button" (click)="goBack()">&times;</div>

            </div>
            <div class="footer-step1">
                <div class="secondary-button" (click)="goToStep(3)">
                    <div>Previous</div>
                </div>
                <div class="primary-button" (click)="goToStep(5)">
                    <div>Next</div>
                </div>
            </div>
            
        </div>
    </div>
</body>






    